export function wrapSingleRowReturnWithResolvers(
  singleRowReturn: string,
  resolvers: string[]
): string {
  return singleRowReturn.replace(/return ([\s\S]+)$/, (_, expression: string) => {
    const lines = [`const singleRow = ${expression}`]
    let current = 'singleRow'

    for (const resolver of resolvers) {
      const resolvedName = resolver.replace(/^resolve/, 'resolved').replace(/Fields$/, 'Row')
      lines.push(`    const [${resolvedName}] = await ${resolver}([${current}])`)
      current = resolvedName
    }

    lines.push(`    return ${current}`)
    return lines.join('\n')
  })
}
